import type { FC } from 'react';
import { useState } from 'react';
import { useCancelOrganizationAssignment } from 'src/apis/monolith/use-cancel-organization-assignment';
import { Button } from 'src/components/buttons-and-actions/button';
import { useOnChange } from 'src/hooks/use-on-change';
import { useToast } from 'src/hooks/use-toasts';
import { CancelOrganizationAssignmentModal } from 'src/pages/operators/assignments/details/components/cancel-organization-assignment-modal';

export const CancelOrganizationAssignmentButton: FC<{
  tsoId: string;
  operatorName: string;
  onCancelSuccess?: () => void;
}> = ({ tsoId, operatorName, onCancelSuccess }) => {
  const [showCancellationModal, setShowCancellationModal] = useState(false);
  const cancelCompanyAssignment = useCancelOrganizationAssignment({
    tsoId,
  });

  const notify = useToast();

  useOnChange(() => {
    setShowCancellationModal(false);

    notify({
      type: 'success',
      children: 'Organisation and user assignments cancelled successfully.',
    });

    onCancelSuccess?.();
  }, cancelCompanyAssignment.response);

  return (
    <>
      <Button
        data-testid="cancel-org-assignment-btn"
        size="small"
        mode="primary"
        onClick={() => setShowCancellationModal(true)}
      >
        Cancel Org. Assignment
      </Button>

      {showCancellationModal && (
        <CancelOrganizationAssignmentModal
          onDismiss={() => setShowCancellationModal(false)}
          cancelAssignment={cancelCompanyAssignment}
          organisationName={operatorName}
        />
      )}
    </>
  );
};
